import type {PinnedRangeMappingHeuristicEntry, LogoRatiosHeuristicEntry} from './types'

export const BASE_HORIZONTAL_PADDING = 24
export const CTX_CONTENT_BOX = 'CONTENT_BOX'
export const CTX_HORIZONTAL_PADDING = 'HORIZONTAL_PADDING'
export const CTX_HORIZONTAL_MARGIN = 'HORIZONTAL_MARGIN'
export const CORNER_PINNED_RANGES: PinnedRangeMappingHeuristicEntry[] = [
    {min: 0, max: 70},
    {min: 71, max: 300, target: 70}
]
export const CENTER_COLUMN_PINNED_RANGES: PinnedRangeMappingHeuristicEntry[] = [
    {min: 0, max: 70},
    {min: 71, max: 300, target: 70}
]
export const CENTER_ROW_PINNED_RANGES: PinnedRangeMappingHeuristicEntry[] = [
    {min: 0, max: 70},
    {min: 71, max: 300, target: 70}
]
export const HEADER_COMPONENTS_WIDTH = {
    MENU_WIDTH: 30,
    COMPONENT_IN_HEADER_WIDTH: 40,
    HEADER_SIDE_MARGINS: 24,
    HEADER_COMPONENT_GAP: 12,
    LOGO_WIDTH_WIDE: 120,
    LOGO_WIDTH_NARROW: 40,
    TPA_WIDTH: 60
}

export const LOGO_RATIOS: LogoRatiosHeuristicEntry[] = [
    {
        min: 1,
        target: HEADER_COMPONENTS_WIDTH.LOGO_WIDTH_NARROW
    },
    {
        min: 0,
        max: 1,
        target: HEADER_COMPONENTS_WIDTH.LOGO_WIDTH_WIDE
    }
]
